import React, { useReducer, useEffect, useState, useRef } from 'react';
import { MainRouter } from './routes/index';
import './App.less';
import User from './core/user';
import { Button, Icon, message, Modal, Radio } from 'antd';
import _ from 'underscore';

import { fetchReducer } from './store/reducers';
import AxiosTS from './core/axios';
import Bus from './core/TBus';
import Voice from './modules/common/Voice';
import Inst from './core/inst';
import { withRouter } from 'react-router-dom';
import './core/ant.less';
import './core/global.less';
declare var window: any;
const antIcon = <Icon type='loading' style={{ fontSize: 24 }} spin />;
export const XMContext: any = React.createContext(null);

const App: React.FC = (props: any) => {
  const [xmState, xmDispatch] = useReducer(fetchReducer, {
    login: false,
    count: 0,
    firstSubMenuId: '',
    menuId: ''
  });
  const [getInst, setGetInst] = useState(false);
  const [instAdminId, setInstAdminId] = useState(undefined);
  const [faceInstList, setFaceInstList] = useState([]);
  const [tipModalVisible, setTipModalVisible] = useState(false);
  const [currentInst, setCurrentInst] = useState({
    bizAccountId: '',
    instId: '',
    version: ''
  });

  if (!User.token()) {
    props.history.push('/login');
  }
  useEffect(() => {
    Bus.bind('spin', (_spin: any) => { });
    AxiosTS.Business('public/b/getUserInstAdminList', {
      uid: User.uid(),
    }).then((res: any) => {
      const insts = res.result;
      if (insts.length === 0) {
        props.history.push('/login');
        return;
      }
      Inst.saveUserInsts(insts);
      let userInstAdminVOList = res.result || [];
      let userAdminInfo = userInstAdminVOList[0] || {};
      window.userAdminInfo = userAdminInfo;
      window.NewVersion = userAdminInfo.saaSVersionEnum == 'V_50';

      getFaceInstList(insts).then((data) => {
        AxiosTS.Business('public/common/queryCommonParams', {}, {reject: true}).then(
          (res: any) => {
            const permissionList = res.result.userPermissionGroupList;
            if (window.NewVersion) {
              localStorage.setItem('w_tid', res.result.teacherId || '');
            }
            window.userPermissionListCodes = _.pluck(permissionList, 'groupCode');
            window.instPermissions = _.pluck(permissionList, 'groupCode');
            if (
              window.userPermissionListCodes.indexOf('FaceAttendance') != -1 ||
              window.userPermissionListCodes.indexOf('1118') != -1
            ) {
              setGetInst(true);
            } else {
              // 当前校区没有权限且其他校区也没有
              if (data.length === 0) {
                Modal.info({
                  title: '当前校区未开通人脸考勤',
                  content: '请先开通人脸考勤功能',
                  okText: '我知道了',
                  icon: <span className="icon iconfont default-confirm-icon">&#xe6f1;</span>,
                  onOk: () => {
                    localStorage.clear();
                    props.history.replace('/login');
                  }
                })
              } else {
                // 当前校区没有权限，其他校区有
                setTipModalVisible(true);
              }
            }
          }
        ).catch(() => {
          props.history.replace('/login');
        })
      })

      setInterval(() => {
        if (window.userAdminInfo.adminId != User.aid()) {
          window.location.reload();
        }
      }, 5000);
    }).catch((error) => {
      console.error(error);
      localStorage.clear();
      props.history.replace('/login');
    })
  }, []);

  // 过滤没有人脸考勤的校区
  function getFaceInstList(insts: any[]) {
    const instIds: any = {};
    _.map(insts, (item: any) => {
      instIds[item.instId] = item.saaSVersionEnum;
    })
    const list: any = [];
    return AxiosTS.Business('public/face/listFaceInst', { instIds }).then((res: any) => {
      const ids = _.pluck(res.result, 'instId');
      _.map(insts, (item: any) => {
        if (ids.includes(item.instId)) {
          list.push(item);
        }
      })
      setFaceInstList(list);
      window.userAdminVOList = list;
      return list;
    })
  }

  // 点击切换校区的时候判断有没有人脸考勤权限，需要每一次都调用权限接口
  // 然后比对当前用户有没有这个权限 ~_~
  function handleClickInst(item: any) {
    setCurrentInst({
      instId: item.instId,
      bizAccountId: item.adminId,
      version: item.saaSVersionEnum
    });
  }

  // 判断是否有人脸权限
  function checkPermission() {
    return AxiosTS.Business(
      'public/common/queryCommonPermissionByVersion',
      currentInst
    ).then((res: any) => {
      // 是否有人脸权限
      const permissionListCode = _.chain(res.result)
        .get('userPermissionGroupList')
        .pluck('groupCode');
      const hasPermissionV4 = permissionListCode.contains('1118').value();
      const hasPermissionV5 = permissionListCode
        .contains('FaceAttendance')
        .value();
      return hasPermissionV4 || hasPermissionV5;
    });
  }

  // 切换校区
  function handleChangeInst() {
    if (!instAdminId) {
      message.warn('请选择校区');
      return;
    }
    const query = {
      adminType: 'INST_ADMIN',
      defaultAdminId: instAdminId,
      userId: User.uid()
    }
    checkPermission().then((hasPermission: boolean) => {
      if (hasPermission) {
        AxiosTS.Business('public/b/changeUserDefaultAdmin', query).then((res) => {
          window.location.reload();
          props.history.push('/home')
        });
      } else {
        Modal.info({
          title: '当前校区未开通人脸考勤',
          content: '请先开通人脸考勤功能',
          okText: '我知道了',
          icon: <span className="icon iconfont default-confirm-icon">&#xe6f1;</span>,
        })
      }
    })
  }

  function onCancel() {
    setTipModalVisible(false);
    localStorage.clear();
    props.history.replace('/login');
  }

  return (
    <XMContext.Provider value={{ xmState, dispatch: xmDispatch }}>
      <div className='App' id='app'>
        {getInst && <MainRouter />}
        <Voice />
      </div>
      <Modal
        title="提示"
        wrapClassName="inst-modal"
        keyboard={false}
        maskClosable={false}
        visible={tipModalVisible}
        onCancel={onCancel}
        onOk={handleChangeInst}
      >
        <div className="modal-title">当前校区未开通人脸考勤</div>
        <div className="inst-container">
          <div className="inst-title">请选择已开通人脸考勤的校区：</div>
          <Radio.Group 
            onChange={(e) => setInstAdminId(e.target.value)} 
            value={instAdminId}
          >
            {
              _.map(faceInstList, (item: any) => (
                <Radio className="inst-item" key={item.instId} value={item.adminId} onClick={() => handleClickInst(item)}>
                  <span style={{ width: '100%', whiteSpace: 'normal' }}>{item.instName}</span>
                </Radio>
              ))
            }
          </Radio.Group>
        </div>
      </Modal>
    </XMContext.Provider>
  );
};

export default withRouter(App);
